import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

export default (reducers) => {
	const persistedReducer = persistReducer(
		{
			key: 'LUCREE-FRONT',
			storage,
			whitelist: ['auth', 'clientMaquinaVirtual'],
			stateReconciler: autoMergeLevel2,
		},
		reducers
	);
	return persistedReducer;
};
